import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';

const endpoint = `${apiUrl}v2`;

// Token and storage management
export const authStorage = {
  setAuth(data) {
    localStorage.setItem('is_logged_in', 'true');
    localStorage.setItem('token', data.token);
    localStorage.setItem(
      'mzad_user_info',
      JSON.stringify({
        ...data.user,
        token: data.token,
      })
    );
  },

  clearAuth() {
    localStorage.removeItem('is_logged_in');
    localStorage.removeItem('token');
    localStorage.removeItem('mzad_user_info');
  },

  getToken() {
    return localStorage.getItem('token');
  },

  isLoggedIn() {
    return localStorage.getItem('is_logged_in') === 'true';
  },

  getUserInfo() {
    const userInfo = localStorage.getItem('mzad_user_info');
    return userInfo ? JSON.parse(userInfo) : null;
  },
};

// API response handler
const handleApiResponse = (response) => {
  console.log('5', response.data);
  if (!response.data) {
    throw new Error('Invalid response from server');
  }
  return response.data;
};

// API error handler
const handleApiError = (error) => {
  return {
    success: false,
    message: error.response?.data?.message || 'Something went wrong',
    status: error.response?.status || 500,
    error: error,
  };
};
//Register
export async function registerUser(payload) {
  try {
    const response = await axios.post(`${endpoint}/auth/register`, payload);
    const data = handleApiResponse(response);
    return { response: data };
  } catch (error) {
    const err = new Error(error.response?.data?.message || 'Something went wrong');
    err.response = error.response;
    err.status = error.response?.status || 500;
    throw err; //  must be throw, not return
  }
}
// Login user
export async function loginUser(payload) {
  try {
    const response = await axios.post(`${endpoint}/auth/login`, payload);
    const data = handleApiResponse(response);

    // If normal login (not OTP required), store auth data
    if (data.data?.user && data.data?.token && !data.data?.requires_verification) {
      authStorage.setAuth({
        user: data.data.user,
        token: data.data.token,
      });
    }

    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Verify OTP
export async function verifyEmailOtp(payload) {
  try {
    const response = await axios.post(`${endpoint}/auth/email/verify`, payload);
    const data = handleApiResponse(response);

    // Store auth data after successful OTP verification
    if (data.data?.user && data.data?.token) {
      authStorage.setAuth({
        user: data.data.user,
        token: data.data.token,
      });
    }

    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function resendEmailOtp(payload) {
  try {
    const response = await axios.post(`${endpoint}/auth/email/resend`, payload);
    const data = handleApiResponse(response);
    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Verify OTP
export async function verifyMobileOtp(payload) {
  try {
    const response = await axios.post(`${endpoint}/auth/otp/verify`, payload);
    const data = handleApiResponse(response);

    // Store auth data after successful OTP verification
    if (data.data?.user && data.data?.token) {
      authStorage.setAuth({
        user: data.data.user,
        token: data.data.token,
      });
    }

    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Resend OTP
// export async function resendMobileOtp(token) {
//   try {
//     const response = await axios.post(`${endpoint}/auth/resend-otp`, {
//       verification_token: token,
//     });
//     return handleApiResponse(response);
//   } catch (error) {
//     throw handleApiError(error);
//   }
// }

// Request OTP for login
export async function requestOtpLogin(payload) {
  try {
    const response = await axios.post(`${endpoint}/auth/otp/request`, payload);
    const data = handleApiResponse(response);
    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Forgot Password
export async function forgotPassword(payload) {
  try {
    const response = await axios.post(`${endpoint}/auth/forgot-password`, payload);
    const data = handleApiResponse(response);
    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Reset Password
export async function resetPassword(payload) {
  try {
    const response = await axios.post(`${endpoint}/auth/reset-password`, payload);
    const data = handleApiResponse(response);
    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Logout
export async function logoutUser() {
  try {
    const token = authStorage.getToken();
    if (token) {
      await axios.post(
        `${endpoint}/auth/logout`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    }
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
    authStorage.clearAuth();
  }
}
